'use strict';
// RNRender is not used for web. An export is still defined to eliminate warnings from bundlers such as esbuild.
const RNRenderer = {};
export { RNRenderer };
